'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { CATALOGO_MOMENTOS, NOTA_MAXIMA, PRIORIDADE_GRUPO, ROTULO_GRUPO, TETO_DIAS_ENTRE_PESQUISAS } from '../../constants/catalogoMomentos';
import type { MomentoGrupo, MomentoPesquisa } from '../../types/pesquisaSatisfacaoTypes';
import { PesquisaSatisfacaoCard } from '../PesquisaSatisfacaoCard';
const GRUPOS: MomentoGrupo[] = (Object.keys(PRIORIDADE_GRUPO) as MomentoGrupo[]).sort((a, b) => PRIORIDADE_GRUPO[a] - PRIORIDADE_GRUPO[b]);
const NOTA_BAIXA: Record<string, number> = {
  CSAT: 2,
  CES: 2
};
function notaAlta(momento: MomentoPesquisa): number {
  return NOTA_MAXIMA[momento.tipo];
}
function Etiqueta(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <span className="text-neutral-0 rounded-md bg-neutral-800 px-2.5 py-1 text-xs font-bold">{children}</span>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
function Vitrine(t0) {
  const $ = _c(15);
  const {
    momento
  } = t0;
  const [comentario, setComentario] = useState("");
  const semAcao = _temp;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      etiqueta: "A",
      titulo: "A pergunta aparece",
      estado: "PERGUNTA" as const,
      nota: null
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = NOTA_BAIXA[momento.tipo] ?? 2;
  let t3;
  if ($[1] !== t2) {
    t3 = {
      etiqueta: "B",
      titulo: "Nota baixa \xB7 nota j\xE1 enviada, coment\xE1rio \xE9 extra",
      estado: "COMENTARIO" as const,
      nota: t2
    };
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== momento) {
    t4 = notaAlta(momento);
    $[3] = momento;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t4) {
    t5 = {
      etiqueta: "C",
      titulo: "Nota alta \xB7 mesma mec\xE2nica, outro tom",
      estado: "COMENTARIO" as const,
      nota: t4
    };
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      etiqueta: "D",
      titulo: "Enviado \xB7 recolhe em 3s",
      estado: "ENVIADO" as const,
      nota: null
    };
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t3 || $[9] !== t5) {
    t7 = [t1, t3, t5, t6];
    $[8] = t3;
    $[9] = t5;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const estados = t7;
  let t8;
  if ($[11] !== comentario || $[12] !== estados || $[13] !== momento) {
    t8 = <div className="flex flex-wrap gap-6">{estados.map(item => <div key={item.etiqueta} className="flex w-[392px] flex-col gap-3"><div className="flex items-center gap-2.5"><Etiqueta>{item.etiqueta}</Etiqueta><span className="text-[15px] font-semibold text-neutral-800">{item.titulo}</span></div><PesquisaSatisfacaoCard momento={momento} estado={item.estado} nota={item.nota} comentario={comentario} progressoPercentual={item.estado === "PERGUNTA" ? 64 : 100} enviandoComentario={false} onSelecionarNota={semAcao} onAlterarComentario={setComentario} onEnviarComentario={semAcao} onFechar={semAcao} onPausarTimer={semAcao} onRetomarTimer={semAcao} /></div>)}</div>;
    $[11] = comentario;
    $[12] = estados;
    $[13] = momento;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
}
function _temp() {}
export function PesquisaSatisfacaoShowcase() {
  const $ = _c(32);
  const [momentoId, setMomentoId] = useState("C2");
  let t0;
  if ($[0] !== momentoId) {
    t0 = CATALOGO_MOMENTOS.find(item => item.id === momentoId) ?? CATALOGO_MOMENTOS[0];
    $[0] = momentoId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const momento = t0;
  if (!momento) {
    return null;
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex max-w-[900px] flex-col gap-3"><span className="text-xs font-semibold tracking-[0.08em] text-neutral-500 uppercase">Pesquisa de satisfação · CSAT e CES</span><h1 className="text-[30px] leading-9 font-semibold text-neutral-800">Um elemento, dois tipos de pesquisa</h1><p className="text-sm leading-[22px] text-neutral-600">O mesmo cartão atende CSAT (1 a 5, com rosto) e CES (1 a 7, numérico). Título, subtítulo, pergunta de follow-up e escala vêm do catálogo de momentos — nenhuma tela declara texto próprio. A nota é gravada no clique; o comentário é sempre opcional e chega num segundo envio. Teto de uma pesquisa a cada {TETO_DIAS_ENTRE_PESQUISAS} dias por usuário — uma por semana.</p></div>;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span className="text-[15px] font-semibold text-neutral-800">Escolha o momento para ver a copy aplicada</span>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== momento.id) {
    t3 = GRUPOS.map(grupo => {
      const momentosDoGrupo = CATALOGO_MOMENTOS.filter(item_0 => item_0.grupo === grupo);
      if (momentosDoGrupo.length === 0) {
        return null;
      }
      return <div key={grupo} className="flex flex-col gap-2"><span className="text-xs font-semibold tracking-wide text-neutral-500 uppercase">{PRIORIDADE_GRUPO[grupo]}. {ROTULO_GRUPO[grupo]}</span><div className="flex flex-wrap gap-2">{momentosDoGrupo.map(item_1 => <button key={item_1.id} type="button" onClick={() => setMomentoId(item_1.id)} className={`cursor-pointer rounded-[8px] border px-3 py-1.5 text-xs font-semibold transition-colors ${item_1.id === momento.id ? "border-brand-600 bg-brand-600 text-neutral-0" : "bg-neutral-0 hover:border-brand-300 border-neutral-200 text-neutral-600"}`}>{item_1.id} · {item_1.tipo}{item_1.eventoConfirmado ? "" : " \xB7  a confirmar"}</button>)}</div></div>;
    });
    $[4] = momento.id;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <div className="flex flex-col gap-4">{t2}{t3}</div>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = ROTULO_GRUPO[momento.grupo];
  let t6;
  if ($[8] !== momento.id || $[9] !== momento.tipo || $[10] !== t5) {
    t6 = <span className="text-[15px] font-semibold text-neutral-800">{momento.id} · {momento.tipo} · {t5}</span>;
    $[8] = momento.id;
    $[9] = momento.tipo;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== momento.evento) {
    t7 = <code className="text-neutral-700">{momento.evento}</code>;
    $[12] = momento.evento;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const t8 = momento.rotaPadrao ? ` · rota ${momento.rotaPadrao}` : "";
  let t9;
  if ($[14] !== momento.amarra || $[15] !== momento.versaoCopy || $[16] !== t7 || $[17] !== t8) {
    t9 = <span className="text-[13px] text-neutral-500">evento {t7}{t8} · amarra: {momento.amarra} · copy v{momento.versaoCopy}</span>;
    $[14] = momento.amarra;
    $[15] = momento.versaoCopy;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t6 || $[20] !== t9) {
    t10 = <div className="flex flex-col gap-1">{t6}{t9}</div>;
    $[19] = t6;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== momento) {
    t11 = <Vitrine momento={momento} />;
    $[22] = momento;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t10 || $[25] !== t11) {
    t12 = <div className="flex flex-col gap-5">{t10}{t11}</div>;
    $[24] = t10;
    $[25] = t11;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <span className="text-[15px] font-semibold text-neutral-800">Catálogo completo · {CATALOGO_MOMENTOS.length} momentos</span>;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <div className="flex flex-col gap-4">{t13}<div className="bg-neutral-0 overflow-x-auto rounded-[16px] border border-neutral-200"><table className="w-full min-w-[900px] border-collapse text-left"><thead><tr className="border-b border-neutral-200 bg-neutral-50"><th className="px-4 py-3 text-xs font-semibold text-neutral-600">#</th><th className="px-4 py-3 text-xs font-semibold text-neutral-600">Tipo</th><th className="px-4 py-3 text-xs font-semibold text-neutral-600">Grupo</th><th className="px-4 py-3 text-xs font-semibold text-neutral-600">Produto</th><th className="px-4 py-3 text-xs font-semibold text-neutral-600">Evento</th><th className="px-4 py-3 text-xs font-semibold text-neutral-600">Colisão</th><th className="px-4 py-3 text-xs font-semibold text-neutral-600">Amarra</th></tr></thead><tbody>{CATALOGO_MOMENTOS.map(_temp2)}</tbody></table></div></div>;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== t12 || $[30] !== t4) {
    t15 = <div className="flex flex-col gap-10 bg-neutral-50 p-12">{t1}{t4}{t12}{t14}</div>;
    $[29] = t12;
    $[30] = t4;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  return t15;
}
function _temp2(item_2) {
  return <tr key={item_2.id} className="border-b border-neutral-100 last:border-b-0"><td className="px-4 py-3 text-[13px] font-semibold text-neutral-800">{item_2.id}</td><td className="px-4 py-3 text-[13px] text-neutral-600">{item_2.tipo}</td><td className="px-4 py-3 text-[13px] text-neutral-600">{ROTULO_GRUPO[item_2.grupo]}</td><td className="px-4 py-3 text-[13px] text-neutral-600">{item_2.produto ?? "\u2014"}{item_2.fluxo ? ` · ${item_2.fluxo}` : ""}</td><td className="px-4 py-3 text-[13px] text-neutral-600">{item_2.evento}{item_2.eventoConfirmado ? "" : " (a confirmar)"}</td><td className="px-4 py-3 text-[13px] text-neutral-600">{item_2.grupoColisao ?? "\u2014"}</td><td className="px-4 py-3 text-[13px] text-neutral-600">{item_2.amarra}</td></tr>;
}